import React, { useEffect, useState } from "react"

import {
    Row,
    Col,
    Card,
    CardBody,
    FormGroup,
    Label,
    Input,
    Container,
    FormFeedback,
    Form,
} from "reactstrap"
// Formik validation
import { useFormik } from "formik"

//Import Breadcrumb
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import { useHistory } from "react-router-dom"
import ResultHandler from "../../../../components/ResultHandler"
import { addInvoiceable } from "../../../../api/invoiceables"
import * as Yup from "yup"
import FormButtonHandler from "../../../../components/FormButtonHandler"
import { useResponse } from "../../../../hooks/useResponse"
import { useTranslation } from "react-i18next"
import FIELDS, { MASTER_FIELDS, MEDIA_FIELDS } from "./CONSTANT"
import InvoiceableForm from "./InvoiceableForm"
import { useParams } from "react-router-dom"

const TYPES = {
    'select': null,
    'add-more': [],
    'checkbox': false,
    'file' : null,
    'date': null
}

const initialValues = {}
const FIELDS_VALIDATION = {}

function getValidationRules(type){
    return MEDIA_FIELDS.forEach(f => {
        initialValues[f.key] = TYPES[f.type] ? TYPES[f.type] : "" 
        if(f.type == 'file'){
            FIELDS_VALIDATION[f.key+"_preview"] = Yup.string().required("This Field Is Required")
    
        }else{
            FIELDS_VALIDATION[f.key] = Yup.string().required("This Field Is Required")
        }
    })
}

const AddInvoiceable = () => {
    const { t } = useTranslation()
    let navigate = useHistory()

    ///// get pool

    const {contractId} = useParams()
    

    const { setData, loading, error, success } = useResponse(addInvoiceable, () => {
        navigate.goBack()
    })


    // Form validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues,
        validationSchema: Yup.object(getValidationRules()),
        onSubmit: data => {
            const finalData = {...data, contract_id: +contractId, price: +(data.price.replace(",", "."))}
            setData({ type: "add", data: finalData})
            // console.log(finalData);
        },
        
    })

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs
                        title={t("Invoiceables")}
                        breadcrumbItem={t("Add Invoiceable")}
                    />
                    
                    <Form
                        className="needs-validation"
                        onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()
                            return false
                        }}
                    >
                        <InvoiceableForm validation={validation} />

                        <FormButtonHandler btnTxt="Add" loading={loading} />

                        <ResultHandler
                            error={error}
                            success={success}
                            successMsg={"Created Successfully!"}
                        />
                    </Form>
                               
                </Container>
            </div>
        </React.Fragment>
    )
}

export default AddInvoiceable